import React, { useEffect, useState } from 'react';
import { Skeleton, App } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';

import {
    useCreatePublicationPartMutation,
    useDeletePublicationMutation,
    useReadPublicationByIdQuery,
    useUpdatePublicationMutation,
} from '../../../../services/publications';
import { PostForm } from './PostForm';
import { createFormData } from '../../../../../../utils/common/createFormData';

export const PostCreateContainer = () => {
    const { id } = useParams();
    const { notification } = App.useApp();
    const navigate = useNavigate();

    const [initial, setInitial] = useState<null | any>();
    const [postCost, setPostCost] = useState<number>(0);
    const [postContent, setPostContent] = useState([]);
    const [open, setOpen] = useState(false);
    const [order, setOrder] = useState(0);

    const {
        data: post,
        isSuccess: isSuccessRead,
        isLoading: isLoadingRead,
        refetch,
    } = useReadPublicationByIdQuery(id);

    const [
        updatePost,
        { isSuccess: isSuccessUpdate, isLoading: isLoadingUpdate },
    ] = useUpdatePublicationMutation();

    const [saveUserContent, { isSuccess: isSuccessPart }] =
        useCreatePublicationPartMutation();

    const [deletePublication, { isSuccess: isSuccessDelete }] =
        useDeletePublicationMutation();

    useEffect(() => {
        if (postContent?.length > 0) {
            if (isSuccessUpdate && isSuccessPart) {
                refetch();
                navigate(-1);
                notification.success({
                    message: 'Пост успешно сохранен',
                    placement: 'top',
                });
            }
        } else if (isSuccessUpdate) {
            refetch();
            navigate(-1);
            notification.success({
                message: 'Пост успешно сохранен',
                placement: 'top',
            });
        }
    }, [isSuccessUpdate, isSuccessPart]);

    useEffect(() => {
        if (isSuccessRead) {
            setInitial({
                description: post.description,
                price: post.price,
                title: post.title,
                background_image: post.background_image,
            });
        }
    }, [isSuccessRead]);

    const onSave = async values => {
        if (values.title === '') {
            return notification.error({
                message: 'Нужно указать название поста',
            });
        }

        const data = {
            title: values.title,
            description:
                !values.description || values.description === 'null'
                    ? null
                    : values.description,
            is_active: true,
            price: !values.price ? null : values.price,
            background_image: values.background_image,
        };
        if (!values.description) delete data.description;
        if (!values.price) delete data.price;

        if (!(values.background_image instanceof File)) {
            delete data.background_image;
        }

        await updatePost({ id: Number(id), body: createFormData(data) });

        postContent?.length > 0 ? await saveContent() : null;
    };

    const saveContent = async () => {
        const newParts = postContent.filter(elem => elem.id === 'new');
        const oldParts = postContent.filter(elem => elem.id !== 'new');

        await Promise.all(
            newParts.map(post => {
                const data = {
                    publication_id: Number(post.publication_id),
                    order: Number(post.order),
                    type: Number(post.type),
                    file: post.file,
                    text: post.text,
                };

                if (!(post.file instanceof File)) {
                    delete data.file;
                }

                return saveUserContent(createFormData(data));
            })
        );

        /*await Promise.all(
            postContent.map(post => {
                return saveUserContent(
                    createFormData({
                        publication_id: Number(post.publication_id),
                        order: Number(post.order),
                        type: Number(post.type),
                        file: post.file,
                        text: post.text,
                    })
                );
            })
        );*/
    };

    const addItem = (item, key) => {
        const userContent = {
            publication_id: Number(id),
            order: Number(order),
            type: Number(item.type),
            file: item.file,
            text: null,
            id: 'new',
            key: 'new' + postContent?.length,
        };

        setOrder(Number(order + 1));
        setPostContent([...postContent, userContent]);
        setOpen(true);
    };

    const deletePost = async id => {
        await deletePublication(id);
    };

    const formik = useFormik({
        onSubmit: onSave,
        initialValues: initial,
    });

    const isEdit = false;

    return initial ? (
        <PostForm
            initialValues={initial}
            onSave={onSave}
            open={open}
            setOpen={setOpen}
            setPostCost={setPostCost}
            addItem={addItem}
            formik={formik}
            postContent={postContent}
            isEdit={isEdit}
            setPostContent={setPostContent}
            saveContent={saveContent}
            loading={isLoadingUpdate}
            deletePost={deletePost}
            isSuccessDelete={isSuccessDelete}
            order={order}
            setOrder={setOrder}
        />
    ) : (
        <Skeleton />
    );
};
